import { defineComponent as _defineComponent } from 'vue'
import SalesBotTripSummary from "@/components/SalesBotTripSummary.vue"
import { useDisplay } from "@/composables/useDisplay"
import { useSalesBotStore } from "@/store/modules/salesBot"
import { pluralize } from "@/utils/string"
import { computed, ref } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'SalesBotTripSummaryPreview',
  setup(__props) {

const salesBotStore = useSalesBotStore()
const { smOnly } = useDisplay()

const isTripSummaryDialogOpen = ref(false)

const tripSummary = computed(() => {
  return salesBotStore.tripSummary
})

const formattedLocationText = computed(() => {
  const { pickupLocation, dropoffLocation } = tripSummary.value
  if (pickupLocation && dropoffLocation) {
    return `${pickupLocation} to ${dropoffLocation}`
  }
  return ''
})

const formattedTimeText = computed(() => {
  const { firstPickupDatetime, lastDropoffDatetime } = tripSummary.value
  if (firstPickupDatetime && lastDropoffDatetime) {
    const formattedPickupTime = firstPickupDatetime.toFormat('MMM d h:mm a')
    const formattedDropoffTime = lastDropoffDatetime.toFormat('MMM d h:mm a')
    return `${formattedPickupTime} - ${formattedDropoffTime}`
  }
  return ''
})

const formattedPassengerText = computed(() => {
  const { passengers } = tripSummary.value
  if (passengers) {
    return `${passengers} ${pluralize(passengers, 'passenger')}`
  }
  return ''
})


return { __sfc: true,salesBotStore, smOnly, isTripSummaryDialogOpen, tripSummary, formattedLocationText, formattedTimeText, formattedPassengerText, SalesBotTripSummary }
}

})